import { ecId, ecLean, handBack, type JanusCtx, type Row } from '../ability/context';
import { encounterField } from '../../shared/array-types';
import { readPlayerCharacterField } from '../display/player-character-field';
import { readItemField } from '../compile/item-field-reader';

/** Only the two ruled, actual-outcome refusals call this. The ordinary ability saver
 * records a separate GM log with no action, damage, costs or death rows. */
export function refuseDeath(ctx: JanusCtx, caster: Row, target: Row, ability: Row, message: string): never {
    if (!ctx.dryRun && typeof window !== 'undefined') {
        const name = String(ecLean(target, 'encounter_creature_name') || readPlayerCharacterField(target, 'player_name') || 'Creature');
        window.dispatchEvent(new CustomEvent('ft:death-refusal', { detail: {
            encounterId: String(encounterField(ctx.encounter, 'encounter_id') ?? ''), actorId: ecId(caster) || ecId(target),
            abilityId: String(readItemField(ability, 'item_id') ?? ''), operationId: ctx.read.uuid(), text: `${name}: ${message}`,
        } }));
    }
    handBack(message);
}

/** Existing page readers normalize lean zero scalars before they become SQL before-values. */
export function deathRefusalCommand(detail: Row, actor: Row, schema: string): Row {
    const id = ecId(actor), before = Object.fromEntries(['aps', 'mana', 'v_current', 'reaction', 'encounter_creature_dead']
        .map(key => [key, Number(ecLean(actor, key) ?? 0)]));
    const revision = Number(ecLean(actor, 'movement_rev') ?? 0);
    return { schema, log_only: true, operation_id: detail.operationId, encounter_id: detail.encounterId, actor_id: id,
        ability_id: detail.abilityId, expected_rev: revision, roll_private: 1, before: { aps: before.aps },
        member_expected_revs: { [id]: revision }, member_before: { [id]: before },
        verdict: { kind: 'resolved', rows: [{ roll_type_1: 'janus_unported_skip', roll_type_2: 'death_refusal', roll_item_id: null,
            roll_by: id, roll_to: null, roll_result: 0, roll_private: 1, rolls_full: detail.text }],
            ec: {}, statusesAdded: [], statusesRemoved: [], statusStacks: [], charges: [], playerCharactersChanged: [],
            inventory: [], deathTail: [], concentrationBreaks: [], forcedMovements: [] } };
}
